import React, { useContext } from "react";
import { DataContext } from "../../Context/Context";
import { Line } from "react-chartjs-2";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 15,
    textAlign: "left",
    margin: 0,
    color: "grey",
    fontWeight: 600,
    padding: "10px 10px",
    backgroundColor: "rgb(240, 238, 238)",
  },
  chart: {
    padding: 10,
  },
}));

export default function ExpensesAndIncome() {
  const classes = useStyles();
  const { income, expense } = useContext(DataContext);

  const data = {
    labels: Array.from(
      {
        length: income.length > expense.length ? income.length : expense.length,
      },
      (_, i) => i + 1
    ),

    datasets: [
      {
        label: "Income",
        data: income.map((i) => {
          return i.amount;
        }),
        fill: false,
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "rgba(255, 99, 132, 0.2)",
        yAxisID: "y-axis-1",
      },
      {
        label: "Expense",
        data: expense.map((e) => {
          return e.amount;
        }),
        fill: false,
        backgroundColor: "rgb(54, 162, 235)",
        borderColor: "rgba(54, 162, 235, 0.2)",
        yAxisID: "y-axis-2",
      },
    ],
  };

  const options = {
    scales: {
      yAxes: [
        {
          type: "linear",
          display: true,
          position: "left",
          id: "y-axis-1",
        },
        {
          type: "linear",
          display: true,
          position: "right",
          id: "y-axis-2",
          gridLines: {
            drawOnArea: false,
          },
        },
      ],
    },
  };

  return (
    <>
      <Paper elevation={3}>
        <h1 className={classes.title}>Expenses and Income</h1>
        <div className={classes.chart}>
          <Line data={data} options={options} />
        </div>
      </Paper>
    </>
  );
}
